import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Stack,
  styled,
  TextField,
  Typography
} from '@mui/material';
import { t } from 'i18next';
import { PaperStyled } from 'pages/RegisterPage';
import { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { palette } from 'styles/theme';
import ReactMarkdown from 'react-markdown';
import tnc from '../tnc.md';

export default function FormStep1Container() {
  const { control, formState } = useFormContext();
  const { errors } = formState;

  const [markdownContent, setMarkdownContent] = useState('');

  useEffect(() => {
    fetch(tnc)
      .then((res) => res.text())
      .then((text) => setMarkdownContent(text));
  }, []);

  return (
    <>
      <Typography color="surface.700" variant="h6" sx={{ mb: 1 }}>
        {t('step1.t&cTitle')}
      </Typography>
      <Box sx={{ mb: 1 }}>
        <Typography color="surface.900" fontWeight="500" variant="body2">
          {t('step1.t&cDesc')}
        </Typography>
      </Box>
      <Box sx={{ color: '#FAFAFA' }}>
        <PaperStyled>
          <Stack>
            <SectionStyled>
              <Box sx={{ maxWidth: '100%' }}>
                <Typography
                  component={'div'}
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    maxHeight: 400,
                    overflow: 'auto'
                  }}
                >
                  <ReactMarkdown>{markdownContent}</ReactMarkdown>
                </Typography>
              </Box>
            </SectionStyled>
          </Stack>
          <Box>
            <Typography variant="body3" color={'surface.300'}>
              Saya,
            </Typography>
          </Box>
          <Grid container sx={{ width: '100%', pb: 5 }}>
            <Grid item xs={6}>
              <Typography variant="body3">Nama Lengkap PIC Perusahaan</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body3">Email PIC Perusahaan</Typography>
            </Grid>
            <Grid item xs={6}>
              <FormControl sx={{ width: '100%', paddingRight: 5 }}>
                <Controller
                  control={control}
                  name="guestName"
                  rules={{ required: 'Field is required' }}
                  render={({ field }) => (
                    <TextField
                      sx={{ py: 1 }}
                      variant="outlined"
                      size="small"
                      placeholder="Name"
                      fullWidth
                      error={errors?.guestName ? true : false}
                      helperText={(errors?.guestName?.message as string) || ''}
                      {...field}
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl sx={{ width: '100%', paddingRight: 5 }}>
                <Controller
                  control={control}
                  name="guestEmail"
                  rules={{
                    required: 'Field is required',
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: 'Berikan alamat email yang valid'
                    }
                  }}
                  render={({ field }) => (
                    <TextField
                      sx={{ py: 1 }}
                      variant="outlined"
                      size="small"
                      placeholder="Name"
                      fullWidth
                      error={Boolean(errors?.guestEmail?.type)}
                      helperText={(errors?.guestEmail?.message as string) || ''}
                      {...field}
                    />
                  )}
                />
              </FormControl>
            </Grid>
          </Grid>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="body3" color={'surface.300'} mb={1}>
              Dengan ini menyatakan,
            </Typography>
            <FormControl
              error={Boolean(errors?.agreement1Step1?.type || errors?.agreement2Step1?.type)}
              sx={{ width: '100%' }}
            >
              <FormGroup>
                <FormControlLabel
                  control={
                    <Controller
                      name="agreement1Step1"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => <Checkbox checked={field.value} {...field} />}
                    />
                  }
                  label="Bahwa saya adalah pejabat yang berwenang sesuai Anggaran Dasar Perusahaan terkini atau pegawai yang diberikan surat kuasa oleh pejabat berwenang pada perusahaan dan selanjutnya menyatakan bahwa data / informasi yang diberikan adalah benar serta membebaskan BSS dalam hal terdapat kesalahan / ketidakbenaran penulisan atas data / informasi yang diberikan dalam aplikasi ini."
                />
                <FormControlLabel
                  control={
                    <Controller
                      name="agreement2Step1"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => <Checkbox checked={field.value} {...field} />}
                    />
                  }
                  label="Bahwa saya telah membaca, mengerti dan memahami sepenuhnya
              informasi produk yang akan dibuka dan setuju serta bersedia tunduk pada
              syarat dan ketentuan pembukaan rekening Giro BSS"
                />
              </FormGroup>
            </FormControl>
          </Box>
        </PaperStyled>
      </Box>
    </>
  );
}

export const SectionStyled = styled(Box)(() => ({
  fontWeight: 600,
  backgroundColor: palette.surface[50],
  padding: 16,
  borderRadius: 4,
  textAlign: 'left',
  marginBottom: 20,
  width: '100%'
}));
